// navela_dashboard.jsx — Navela fleet admin dashboard layout.
// Owns the active tab and renders the matching resource manager under the header.

import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import NavelaHeaderBar from '../constant_components/header_bar';
import VesselsManager from './vessels_manager';
import ShipRoutesManager from './ship_routes_manager';
import VesselImagesManager from './vessel_images_manager';
import ArticlesManager from './articles_manager';
import AccountDeletionsManager from './account_deletions_manager';
import MetricsManager from './metrics_manager';

export default function NavelaDashboard() {
  const [activeTab, setActiveTab] = useState('vessels');

  const renderContent = () => {
    switch (activeTab) {
      case 'vessels':
        return <VesselsManager />;
      case 'ship_routes':
        return <ShipRoutesManager />;
      case 'vessel_images':
        return <VesselImagesManager />;
      case 'articles':
        return <ArticlesManager />;
      case 'account_deletions':
        return <AccountDeletionsManager />;
      case 'metrics':
        return <MetricsManager />;
      default:
        return <VesselsManager />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <NavelaHeaderBar activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="fade-in-enter-active">{renderContent()}</main>
    </div>
  );
}
